/**
 * Multipart upload helpers with optional XHR progress.
 */

/**
 * POST FormData with credentials; optional upload progress callback.
 * @param {string} url
 * @param {FormData} formData
 * @param {{ onProgress?: (percent: number) => void }} [options]
 * @returns {Promise<any>} Parsed JSON body
 */
export function uploadFormData(url, formData, options = {}) {
  const { onProgress } = options;
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.withCredentials = true;

    if (typeof onProgress === 'function' && xhr.upload) {
      xhr.upload.onprogress = (event) => {
        if (!event.lengthComputable || !event.total) return;
        const percent = Math.min(100, Math.round((event.loaded / event.total) * 100));
        onProgress(percent);
      };
    }

    xhr.onload = () => {
      let body = {};
      try {
        body = xhr.responseText ? JSON.parse(xhr.responseText) : {};
      } catch {
        body = {};
      }
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(body);
        return;
      }
      reject(new Error(body.error || `Upload failed (${xhr.status})`));
    };

    xhr.onerror = () => reject(new Error('Upload failed'));
    xhr.send(formData);
  });
}
